// extracted by mini-css-extract-plugin
export default {"noRules":"styles_noRules__8Yd8s","rulesActionsContainer":"styles_rulesActionsContainer__dvxSm"};